import React, { Component } from "react";
import Code from "./code";

class ExtensionManifest extends Component {
  render() {
    return (
      <div>
        <p>
          <span>
            The manifest file is a text file that uses the JSON format. It
            contains objects with the properties listed below.
          </span>
        </p>
        <p>
          <span>Note</span> <span> – Required fields are in </span> <b>bold</b>
          <span>.</span>
        </p>
        <table cellSpacing="0" cellPadding="0">
          <tbody>
            <tr>
              <th className="table-top-header-left">
                <p>
                  <span>Parameter name</span>
                </p>
              </th>
              <th className="table-top-header-right">
                <p>
                  <span>Description</span>
                </p>
              </th>
            </tr>

            <tr>
              <td rowSpan="2" className="table-inner-header-left">
                <p>
                  <span>extension</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>General extension details.</span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header">
                <table cellSpacing="0" cellPadding="0">
                  <tbody>
                    <tr>
                      <th className="table-inner-cell-left">
                        <p>
                          <span>Parameter name</span>
                        </p>
                      </th>
                      <th className="table-inner-cell-right">
                        <p>
                          <span>Description</span>
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>name</span>
                        </p>
                      </td>
                      <td className="table-cell-right">
                        <p>
                          <span>The displayed name of your extension.</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>description</span>
                        </p>
                      </td>
                      <td className="table-cell-right">
                        <p>
                          <span>A descriptive text for your extension.</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>product-url</span>
                        </p>
                      </td>
                      <td className="table-cell-right">
                        <p>
                          <span>Path to your extension information page.</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>provider</span>
                        </p>
                      </td>
                      <td className="table-cell-right">
                        <p>
                          <span>Extension provider name.</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>version</span>
                        </p>
                      </td>
                      <td className="table-cell-right">
                        <p>
                          <span>
                            Your own extension version (for version control).
                          </span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>extension-version-requirements</span>
                        </p>
                      </td>
                      <td className="table-cell-bottom_right">
                        <p>
                          <span>
                            Your{" "}
                            <a href="#Extension Versions Requirements">
                              Extension Versions Requirements
                            </a>
                            .
                          </span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td rowSpan="2" className="table-inner-header-left">
                <p>
                  <span>locations</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>
                    A list of locations where extensions requests are hosted
                    inside SmartConsole.
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header">
                <table cellSpacing="0" cellPadding="0">
                  <tbody>
                    <tr>
                      <th className="table-inner-cell-left">
                        <p>
                          <span>Parameter name</span>
                        </p>
                      </th>
                      <th className="table-inner-cell-right">
                        <p>
                          <span>Description</span>
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>location</span>
                        </p>
                      </td>
                      <td className="table-cell-right">
                        <p>
                          <span>
                            The location identifier where your request is
                            hosted.
                            <br />
                            See supported types in{" "}
                            <a href="#Extension Locations">
                              Extension Locations
                            </a>
                            .
                          </span>
                        </p>
                      </td>
                      <td />
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>relevant-types</span>
                        </p>
                      </td>
                      <td className="table-cell-right">
                        <p>
                          <span>
                            A list of specific hosting locations. This
                            definition is
                            <br />
                            correlated with the Extension Context event’s
                            locations.
                            <br />
                            See supported types in{" "}
                            <a href="#Extension Locations">
                              Extension Locations
                            </a>
                            .
                          </span>
                        </p>
                      </td>
                      <td />
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>ui-element</span>
                        </p>
                      </td>
                      <td className="table-cell-bottom_right">
                        <p>
                          <span>
                            Definition of UI elements behavior and
                            visualization.
                            <br />
                            See supported elements in{" "}
                            <a href="#UI Elements">UI Elements</a>.
                          </span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr id="resource-urls">
              <td className="table-inner-header-left" rowSpan="2">
                <p>
                  <span>requested-permissions</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>
                    The requested permissions reflects the content you provide.
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header">
                <table cellSpacing="0" cellPadding="0">
                  <tbody>
                    <tr>
                      <th className="table-inner-cell-left">
                        <p>
                          <span>Parameter name</span>
                        </p>
                      </th>
                      <th className="table-inner-cell-right">
                        <p>
                          <span>Description</span>
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>client</span>
                        </p>
                      </td>
                      <td className="table-cell-bottom_right">
                        <p>
                          <span>
                            Content you receive from SmartConsole.
                            <br />
                            See supported elements in{" "}
                            <a href="#Extension Permissions">
                              Extension Permissions
                            </a>
                            .
                          </span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>resource-urls</span>
                        </p>
                      </td>
                      <td className="table-cell-right">
                        <p>
                          <span>
                            List of pre-defined URL prefixes that the extension
                            is allowed to access (local URLs are implicitly
                            allowed).
                            <br />
                            Relevant when using the{" "}
                            <a href="#Extension Permissions">
                              run-read-only-commands
                            </a>{" "}
                            permission.
                          </span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>pre-approved-commands</span>
                        </p>
                      </td>
                      <td className="table-cell-bottom_right">
                        <p>
                          <span>
                            <b>(Version 1.3+)</b> A list of interaction names shown to the user during installation. By approving these interactions upfront, the user allows the extension to use them later without requiring additional approval. Default: empty list
                          </span>
                        </p>
                        <p>
                          <span>Example:</span>
                        </p>
                        <Code>
{`"pre-approved-commands": ["add-host", "set-host"]`}
                        </Code>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td rowSpan="2" className="table-inner-header-left ">
                <p>
                  <span>custom-data</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>
                    A key-value textual pair for any properties you want the
                    user to customize.
                    <br />
                    <strong> Note</strong>
                    <span> – Customization scope is per user and station.</span>
                  </span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>

        <h4 id="Extension Versions Requirements">
          Extension Versions Requirements
        </h4>

        <table cellSpacing="0" cellPadding="0">
          <tbody>
            <tr>
              <th className="table-top-header-left">
                <p>
                  <span>Parameter name</span>
                </p>
              </th>
              <th className="table-top-header-right">
                <p>
                  <span>Description</span>
                </p>
              </th>
            </tr>
            <tr>
              <td className="table-inner-header-left">
                <p>
                  <span>minimum-version</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>
                    Minimal required SmartConsole extension platform version
                    that your extension can be installed on.
                  </span>
                </p>
                <p>
                  <span>
                    See{" "}
                    <a href="#Extension Versions">
                      SmartConsole extension platform available versions
                    </a>
                    .
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header-left">
                <p>
                  <span>force-version</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>
                    Force extension platform to communicate with your extension
                    in a specific version, as if this is the{" "}
                    <a href="#Extension Versions">platform version</a>.
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header-left">
                <p>
                  <span>version-fallback-manifest</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>
                    Key-Value dictionary of version and manifest URL to use in
                    case minimum version requierment is not met.
                  </span>
                </p>
                <p>
                  <span>
                    <b>Note</b> - extension platform will use the first manifest
                    that could be supported.
                  </span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 id="UI Elements">UI Element</h4>
        <p>
          Define visual properties and behavior for each location your extension
        </p>
        <p>
          <b>Note</b> - Required fields are in <b>bold.</b>
        </p>
        <ul>
          <table cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <th className="table-top-header-left">
                  <p>
                    <span>Parameter name</span>
                  </p>
                </th>
                <th className="table-top-header-right">
                  <p>
                    <span>Description</span>
                  </p>
                </th>
              </tr>
              <tr>
                <td rowSpan="2" className="table-inner-header-left">
                  <p>
                    <span>ui-element</span>
                  </p>
                </td>
                <td className="table-inner-header-right">
                  <p>
                    <span>
                      Definition of UI elements behaviour and visualization.
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td className="table-inner-header">
                  <table cellSpacing="0" cellPadding="0">
                    <tbody>
                      <tr>
                        <th className="table-inner-cell-left">
                          <p>
                            <span>Parameter name</span>
                          </p>
                        </th>
                        <th className="table-inner-cell-right">
                          <p>
                            <span>Description</span>
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <td className="table-cell-left">
                          <p>
                            <span>
                              <b>caption</b>
                            </span>
                          </p>
                        </td>
                        <td className="table-cell-right">
                          <p>
                            <span>A textual name for your UI element.</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className="table-cell-left">
                          <p>
                            <span>type</span>
                          </p>
                        </td>
                        <td className="table-cell-right">
                          <p>
                            <span>See supported types in</span>
                            <span>Extension Locations.</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className="table-cell-left">
                          <p>
                            <span>items</span>
                          </p>
                        </td>
                        <td className="table-cell-right">
                          <p>
                            <span>
                              A list of sub UI elements (not supported in all
                              locations)
                              <br />
                              See supported types in{" "}
                              <a href="#Extension Locations">
                                Extension Locations
                              </a>
                              .
                            </span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className="table-cell-left">
                          <p>
                            <span>action</span>
                          </p>
                        </td>
                        <td className="table-cell-right">
                          <p>
                            <span>
                              This{" "}
                              <a href="#UI Element Action">
                                UI element action definition
                              </a>
                              .
                            </span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className="table-cell-left">
                          <p>
                            <span>tooltip</span>
                          </p>
                        </td>
                        <td className="table-cell-bottom_right">
                          <p>
                            <span>
                              A descriptive text for your Extension action.
                            </span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </ul>
        <h4 id="UI Element Action">UI Element Action</h4>
        <ul>
          <table cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <th className="table-top-header-left">
                  <p>
                    <span>Parameter name</span>
                  </p>
                </th>
                <th className="table-top-header-right">
                  <p>
                    <span>Description</span>
                  </p>
                </th>
              </tr>
              <tr>
                <td className="table-cell-left">
                  <p>
                    <span>details-level</span>
                  </p>
                </td>
                <td className="table-cell-right">
                  <p>
                    <span>
                      The level of detail for some of the fields in the context
                      response can vary from showing only the UID value of the
                      object to a minimal to fully detailed representation of
                      the object.
                    </span>
                  </p>
                  <p>
                    Valid values:
                    <ul>
                      <li>uid</li>
                      <li>standard</li>
                      <li>full</li>
                    </ul>
                    Default: standard
                  </p>
                </td>
              </tr>
              <tr>
                <td className="table-cell-left">
                  <p>
                    <span>method</span>
                  </p>
                </td>
                <td className="table-cell-right">
                  <p>
                    <span>
                      The HTTPS method for SmartConsole to receive requests to
                      your extension.
                    </span>
                  </p>
                  <p>
                    Valid values:
                    <ul>
                      <li>get</li>
                      <li>post</li>
                    </ul>
                    Default: get
                  </p>
                </td>
              </tr>
              <tr>
                <td className="table-cell-left">
                  <p>
                    <span>trigger-id</span>
                  </p>
                </td>
                <td className="table-cell-right">
                  <p>
                    <span>
                      A unique textual identification of the action. Use this
                      action to determine which action was triggered.
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td className="table-cell-left">
                  <p>
                    <span>url</span>
                  </p>
                </td>
                <td className="table-cell-right">
                  <p>
                    <span>The URL for the Extension Service entry point.</span>
                  </p>
                  <p>
                    <span>The URL can be:</span>
                  </p>
                  <ul>
                    <li>
                      Absolute - <i>e.g. https://acme.com/example/index.html</i>
                      .
                    </li>
                    <li>
                      Relative to host - <i>e.g. /example/index.html</i>.
                    </li>
                    <li>
                      Relative to manifest -
                      <i>
                        e.g. index.html (when manifest URL is
                        https://acme.com/example/manifest.json)
                      </i>
                      .
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="table-cell-left">
                  <p>
                    <span>disable-automatic-refresh</span>
                  </p>
                </td>
                <td className="table-cell-right">
                  <p>
                    <span>
                      <b>(Version 1.3+)</b> Set to true to prevent the extension page from automatically refreshing when the context changes. Default: false.
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td rowSpan="2" className="table-inner-header-left">
                  <p>
                    <span>browser-window</span>
                  </p>
                </td>
                <td className="table-inner-header-right">
                  <p>
                    <span>
                      Content window definition (not supported in all
                      locations).
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td className="table-inner-header">
                  <table cellSpacing="0" cellPadding="0">
                    <tbody>
                      <tr>
                        <th className="table-inner-cell-left">
                          <p>
                            <span>Parameter name</span>
                          </p>
                        </th>
                        <th className="table-inner-cell-right">
                          <p>
                            <span>Description</span>
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <td className="table-cell-left">
                          <p>
                            <span>width</span>
                          </p>
                        </td>
                        <td className="table-cell-right">
                          <p>
                            <span>
                              A numerical value for the desired width.
                            </span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className="table-cell-left">
                          <p>
                            <span>height</span>
                          </p>
                        </td>
                        <td className="table-cell-right">
                          <p>
                            <span>
                              A numerical value to for the desired height.
                            </span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className="table-cell-left">
                          <p>
                            <span>min-width</span>
                          </p>
                        </td>
                        <td className="table-cell-right">
                          <p>
                            <span>
                              A numerical value for the minimum width.
                            </span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className="table-cell-left">
                          <p>
                            <span>min-height</span>
                          </p>
                        </td>
                        <td className="table-cell-right">
                          <p>
                            <span>
                              A numerical value for the minimum height.
                            </span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className="table-cell-left">
                          <p>
                            <span>modal-dialog</span>
                          </p>
                        </td>
                        <td className="table-cell-right">
                          <p>
                            <span>
                              A Boolean value (true/false) to determine if the
                              window that contains the extension blocks
                              interacts with the rest of SmartConsole when it is
                              open.
                            </span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className="table-cell-bottom-left">
                          <p>
                            <span>resizable</span>
                          </p>
                        </td>
                        <td className="table-cell-bottom_right">
                          <p>
                            <span>
                              A Boolean value (true/false) to determine content
                              window resize behavior.
                            </span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </ul>
      </div>
    );
  }
}

export default ExtensionManifest;
